@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}

<h1 data-automation-name="systemPropertyEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit System Property {{property.key}}</span>
    }
    @case(false) {
      <span>Register a new System Property</span>
    }
  }
</h1>

<form [formGroup]="systemPropertyForm" class="form-horizontal">
  <div class="form-group">
    <label for="propertyKeyId">Property key:</label>
    <input
      id="propertyKeyId"
      class="form-control"
      name="propertyKey"
      type="text"
      formControlName="propertyKeyId"
      required>
  </div>

  <div class="form-group">
    <label for="propertyType">Property type:</label>
    <select
      id="propertyType"
      class="form-control"
      name="propertyType"
      type="select"
      formControlName="propertyType"
      required>
      <option value="bool">Boolean</option>
      <option value="int">Integer</option>
      <option value="string">String</option>
      <option value="duration">Duration</option>
      <option value="dttm">Date</option>
      <option value="time">Time</option>
    </select>
  </div>

  <div class="bg-info row">
    @switch(property.type) {
      @case('bool') {
        <span>Value may be "true" or "false".</span>
      }
      @case('int') {
        <span>Value may be any whole number.</span>
      }
      @case('string') {
        <span>Value may be any string shorter than 255 characters.</span>
      }
      @case('duration') {
        <span>Value must be an ISO duration. ("PT7H" for 7 hours or "P7D" for 7 days, for example)</span>
      }
      @case('dttm') {
        <span>Value must be an ISO datetime in UTC. ("2017-07-26Z" and "2017-07-26T14:37:00Z" are both valid formats)</span>
      }
      @case('time') {
        <span>Value must be an ISO time. ("14:37:00" and "14:37" are both valid formats)</span>
      }
    }
  </div>

  <div class="form-group">
    <label for="propertyValue">Property value:</label>
    <input
      id="propertyValue"
      class="form-control"
      name="propertyValue"
      type="text"
      formControlName="propertyValue"
      required>
  </div>

  <button id="save" class="btn btn-primary" type="button" (click)="save()">Save</button>
  <a class="btn" (click)="backPage('/systemProperties', router)">Cancel</a>
</form>
